import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { ref, onValue } from "firebase/database";

function Timetableform1() {
  const [formData, setFormData] = useState({ class: "", division: "" });
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [currentTimetable, setCurrentTimetable] = useState({});
  const [isFieldsVisible, setIsFieldsVisible] = useState(false);
  const [numberOfPeriods, setNumberOfPeriods] = useState(0); 
  const [periods, setPeriods] = useState([]); 
  const [isLoading, setIsLoading] = useState(false); 
  const [errorMessage, setErrorMessage] = useState(""); 
  const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [schoolData, setSchoolData] = useState(null); 
 

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };

    const fetchSchoolData = async () => {
      if (udiseNumber) {
        try {
          const db = await openIndexedDB();
          const transaction = db.transaction(['schoolData'], 'readonly');
          const objectStore = transaction.objectStore('schoolData');
          const request = objectStore.get(udiseNumber);
  
          request.onsuccess = (event) => {
            const data = event.target.result;
            if (data) {
              setSchoolData(data);
            }
          };
  
          request.onerror = (event) => {
            console.error("Error fetching school data:", event.target.error);
          };
        } catch (error) {
          console.error('Error fetching school data:', error);
        }
      }
    };
  
    useEffect(() => {
      fetchSchoolData ();
  }, [udiseNumber]);



  // Fetch number of periods from Firebase
  useEffect(() => {
    setIsLoading(true);
    const periodsRef = ref(db, `schoolRegister/${udiseNumber}/periods/`);
    onValue(periodsRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setNumberOfPeriods(data.numberOfPeriods || 0);
        const periodsArray = Array.from({ length: data.numberOfPeriods || 0 }, (_, i) => i + 1); // Generate array [1, 2, ..., n]
        setPeriods(periodsArray);
      } else {
        setNumberOfPeriods(8); // Default to 8 periods if not found
        setPeriods(Array.from({ length: 8 }, (_, i) => i + 1));
      }
      setIsLoading(false);
    });
  }, []);

  // Fetch classes from Firebase
  useEffect(() => {
    setIsLoading(true);
    const timeRef = ref(db, `schoolRegister/${udiseNumber}/periodAssign/`);
    onValue(timeRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const classNames = Object.keys(data);
        setClasses(classNames);
      } else {
        setErrorMessage("Please Create Timetable First.");
      }
      setIsLoading(false);
    });
  }, []);

  // Fetch divisions for the selected class
  useEffect(() => {
    if (formData.class) {
      setIsLoading(true);
      const timeRef = ref(db, `schoolRegister/${udiseNumber}/periodAssign/${formData.class}`);
      onValue(timeRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          setDivisions(Object.keys(data));
        } else {
          setDivisions([]);
        }
        setIsLoading(false);
      });
    }
  }, [formData.class]);

  
  // Fetch timetable for the selected class and division
  useEffect(() => {
    if (formData.class && formData.division) {
      setIsLoading(true);
      const timeRef = ref(db, `schoolRegister/${udiseNumber}/periodAssign/${formData.class}/${formData.division}`);
      onValue(timeRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const formattedTimetable = {};

          // Format data to include empty slots for unfilled periods
          weekdays.forEach((weekday) => {
            formattedTimetable[weekday] = {};

            // Fill all periods with default empty data
            periods.forEach((period) => {
              formattedTimetable[weekday][period] = {
                subject: "-",
                teacher: "-",
                time: "-",
              };
            });
          });

          // Populate timetable with actual data from Firebase
          Object.keys(data).forEach((teacher) => {
            const teacherData = data[teacher];
            Object.keys(teacherData).forEach((weekday) => {
              const weekdayData = teacherData[weekday];
              Object.keys(weekdayData).forEach((period) => {
                const periodNumber = parseInt(period, 10);
                const { subject, teacher, startTime, endTime } = weekdayData[period];

                formattedTimetable[weekday][periodNumber] = {
                  subject: subject || "-",
                  teacher: teacher || "-",
                  time: startTime && endTime ? `${startTime} - ${endTime}` : "-",
                };
              });
            });
          });

          setCurrentTimetable(formattedTimetable);
          setIsFieldsVisible(true);
        } else {
          setCurrentTimetable({});
          setIsFieldsVisible(false);
        }
        setIsLoading(false);
      });
    }
  }, [formData.class, formData.division, periods]);

  // Handle class and division selection
  const handleClassDivisionChange = (field, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
      ...(field === "class" ? { division: "" } : {}),
    }));
  };

  return (
    <div className="main-content-of-page">
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #print-section, #print-section * {
              visibility: visible;
            }
            #print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              padding: 20px;
              box-sizing: border-box;
            }
            .no-print {
              display: none !important;
            }

          
            @page {
              size: A4 landscape !important;
              margin: 10mm;
            }
           
            table {
              width: 100%;
              border-collapse: collapse;
            }
            th, td {
              border: 1px solid #000;
              padding: 8px;
              text-align: center;
            }
            th {
              background-color: #f2f2f2;
            }
          }
        `}
      </style>
      <div>
        <h1 style={{ textAlign: "center", marginBottom: "20px", fontSize: "24px" }}>
          Class Timetable
        </h1>

        {/* Error message */}
        {errorMessage && <div style={{ color: "red", marginBottom: "20px" }}>{errorMessage}</div>}

        {/* Class and Division Selection */}
        {!errorMessage && (
          <div style={{ display: "flex", gap: "20px" }} className="no-print">
            <select 
              style={{ width: "100%", padding: "10px", margin: "10px 0", border: "1px solid black" }}
              value={formData.class}
              onChange={(e) => handleClassDivisionChange("class", e.target.value)}
            >
              <option value="">Select Class</option>
              {classes.map((cls) => (
                <option key={cls} value={cls}>
                  {cls}
                </option>
              ))}
            </select>

            <select 
              style={{ width: "100%", padding: "10px", margin: "10px 0", border: "1px solid black" }}
              value={formData.division}
              onChange={(e) => handleClassDivisionChange("division", e.target.value)}
              disabled={!formData.class}
            >
              <option value="">Select Division</option>
              {divisions.map((div) => (
                <option key={div} value={div}>
                  {div}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Timetable Table */}
        {isFieldsVisible && !errorMessage && (
          <>
            <div id="print-section">
              {/* Display selected class and division */}
              <h2 style={{ textAlign: "center", fontSize: "22px" }}>{schoolData.schoolName}</h2>
              <h5 style={{ textAlign: "center", fontSize: "14px" }}>Tal.:- {schoolData.taluka}, Dist.:- {schoolData.jilha}</h5>
              <h5 style={{ textAlign: "center", marginBottom: "10px", fontSize: "16px" }}>
                Class: {formData.class} - Division: {formData.division}
              </h5>
              <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                tableLayout: "fixed", marginTop:'40px',
              }}
            >
              <thead style={{ backgroundColor: "#84c2fc" }}>
                <tr style={{ color: "black" }}>
                  <th style={{ border: "1px solid black", padding: "7px", textAlign: "center", width: "106px", backgroundColor: "#4caf50" }}>
                    Weekday
                  </th>
                  {periods.map((period) => (
                    <th
                      key={period}
                      style={{ border: "1px solid black", padding: "7px", textAlign: "center", backgroundColor: "#4caf50" }}
                    >
                      Period {period}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {weekdays.map((weekday) => (
                  <tr key={weekday}>
                    <td style={{ border: "1px solid black", padding: "7px", textAlign: "center" }}>
                      {weekday}
                    </td>
                    {periods.map((period) => (
                      <td
                        key={period}
                        style={{
                          border: "1px solid black",
                          padding: "7px",
                          textAlign: "center",
                        }}
                      >
                        {currentTimetable[weekday]?.[period]?.subject !== "-" ? (
                          <>
                            <p style={{ marginBottom: "0rem" }}>
                              Subject: {currentTimetable[weekday][period].subject}
                            </p>
                            <p style={{ marginBottom: "0rem" }}>
                              Teacher: {currentTimetable[weekday][period].teacher}
                            </p>
                            <p style={{ marginBottom: "0rem" }}>
                              Time: {currentTimetable[weekday][period].time}
                            </p>
                          </>
                        ) : (
                          "-"
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
            <button
              className="no-print"
              style={{
                marginTop: "20px",
                padding: "10px 20px",
                backgroundColor: "#8A1538",
                color: "white",
                border: "1px solid black",
                cursor: "pointer",
              }}
              onClick={() => {
                const printContent = document.getElementById("print-section").innerHTML;
                const originalContent = document.body.innerHTML;
                
                document.body.innerHTML = `
                  <div style="border: 2px solid #000; padding: 20px;">
                    ${printContent}
                  </div>
                `;
                window.print();
                document.body.innerHTML = originalContent;
              }}
            >
              Print Timetable
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Timetableform1;